import axios from 'axios';
import { getClientAppId } from '../utils/platform';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.boltin.com';
const AUTH_API_PATH = '/api/auth';

const setAuthToken = (token) => {
  if (token) axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  else delete axios.defaults.headers.common['Authorization'];
};

const register = async (userData) => {
  const response = await axios.post(`${API_BASE_URL}${AUTH_API_PATH}/register`, userData);
  return response.data; // No need to set token here, admin is already logged in
};

const login = async (userData, options = {}) => {
  const clientAppId = options.clientAppId || getClientAppId();
  const headers = {};
  if (clientAppId) {
    headers['X-Client-App'] = clientAppId;
  }
  const response = await axios.post(`${API_BASE_URL}${AUTH_API_PATH}/login`, userData, { headers });
  if (response.data.token) {
    localStorage.setItem('token', response.data.token);
    setAuthToken(response.data.token);
  }
  return response.data;
};

const verifyMfa = async ({ challengeToken, code }) => {
  const response = await axios.post(`${API_BASE_URL}${AUTH_API_PATH}/mfa/verify`, {
    challengeToken,
    code,
  });
  if (response.data.token) {
    localStorage.setItem('token', response.data.token);
    setAuthToken(response.data.token);
  }
  return response.data;
};

const logout = () => {
  localStorage.removeItem('token');
  setAuthToken(null);
};

const getMe = async () => {
  const token = localStorage.getItem('token');
  if (token) setAuthToken(token);
  const response = await axios.get(`${API_BASE_URL}${AUTH_API_PATH}/me`);
  return response.data;
};

// --- NEW FUNCTIONS ---
const getUsers = async (params = {}) => {
  const response = await axios.get(`${API_BASE_URL}${AUTH_API_PATH}/users`, { params });
  return response.data;
};

const updateUser = async (id, userData) => {
  const response = await axios.put(`${API_BASE_URL}${AUTH_API_PATH}/users/${id}`, userData);
  return response.data.data;
};

const deactivateUser = async (id) => {
  const response = await axios.delete(`${API_BASE_URL}${AUTH_API_PATH}/users/${id}`);
  return response.data.data;
};

const reactivateUser = async (id) => {
  const response = await axios.patch(`${API_BASE_URL}${AUTH_API_PATH}/users/${id}/reactivate`);
  return response.data.data;
};

const requestPasswordReset = async (email) => {
  const response = await axios.post(`${API_BASE_URL}${AUTH_API_PATH}/forgot-password`, { email });
  return response.data;
};

const resetPassword = async ({ token, password, pin }) => {
  const response = await axios.post(`${API_BASE_URL}${AUTH_API_PATH}/reset-password`, { token, password, pin });
  return response.data;
};

const changeMyCredentials = async ({ currentPassword, newPassword, newPin }) => {
  const response = await axios.put(`${API_BASE_URL}${AUTH_API_PATH}/me/change-credentials`, {
    currentPassword,
    newPassword,
    newPin,
  });
  return response.data;
};

const authService = { 
  register, login, logout, getMe, setAuthToken,
  verifyMfa,
  getUsers, updateUser, deactivateUser, reactivateUser,
  requestPasswordReset, resetPassword, changeMyCredentials,
};
export default authService;
